<div class="card dialog-box">
  <div class="card-header">
    Queued Events

    <span class="text-primary fw-semibold ms-4">{{
      queuedResposeListData?.length
    }}</span>
    @if (pendingItemCount >= queuedResposeListData?.length) {
      / {{ pendingItemCount }}
    }
    <span (click)="onDialogClose()" class="float-end">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  @if (queuedResposeListData?.length) {
    <ng-container>
      @if (offlineMode) {
        <div class="small-font mb-3">
          Events will be uploaded once the server connection has been restored.
        </div>
      }
      <!-- @if (queuedResposeListData?.length > 1 && !offlineMode) {
        <div class="text-end mb-3">
          <button
            (click)="deleteAllItems()"
            class="btn btn-danger btn-sm"
            [disabled]="syncInProgress"
          >
            Remove All Updates
          </button>
        </div>
      } -->
      @if (!offlineMode) {
        @if (syncInProgress === true) {
          <div
            class="alert alert-primary mb-3 align-items-center d-flex justify-content-between"
          >
            <div class="fw-bold">Syncing Data to Server</div>
            <div class="spinner-grow" role="status"></div>
          </div>
        } @else if (queuedResposeListData?.length) {
          <div class="text-danger mb-3">Error processing queue</div>
        }
      }

      <!--api returns an empty client list-->
      <div class="custom-scroll" [style.max-height.vh]="80">
        @for (queueItem of queuedResposeListData; track queueItem) {
          <div class="border border-secondary p-2 rounded mb-2 small">
            <dl class="d-flex flex-column gap-1">
              <div class="d-flex justify-content-between align-items-center">
                <dt class="mb-0">Status</dt>
                @if (
                  queueItem?.indexDBId &&
                  queueItem?.errorMessages?.[
                    queueItem?.errorMessages?.length - 1
                  ] != "ERROR: Missing Device Details"
                ) {
                  <button
                    class="btn btn-sm btn-outline-danger"
                    (click)="deleteQueuedItem(queueItem)"
                  >
                    Delete
                  </button>
                }
              </div>
              <dd
                [ngClass]="
                  queueItem?.errorMessages?.length ? 'text-danger' : 'text-info'
                "
              >
                @if (queueItem?.errorMessages?.length) {
                  Error:
                  {{
                    queueItem?.errorMessages[
                      queueItem?.errorMessages?.length - 1
                    ]
                  }}
                } @else {
                  In Queue
                }
              </dd>
            </dl>

            <div class="d-flex flex-wrap column-gap-4 row-gap-3">
              @if (
                ["api/patrol/scan_checkpoint/"].includes(queueItem?.pathName)
              ) {
                <dl>
                  <dt>Patrol Event</dt>
                  <dd>
                    {{
                      queueItem?.qr_text
                        ? (queueItem?.checkpointDetail | misc: "jsonParse")
                            ?.cp_type === 2
                          ? "NFC Scan"
                          : "QR Scan"
                        : "Checkpoint Scan"
                    }}
                  </dd>
                </dl>

                <dl>
                  <dt>Checkpoint</dt>
                  <dd>
                    {{
                      (queueItem?.checkpointDetail | misc: "jsonParse")?.name
                    }}
                  </dd>
                </dl>

                @if (
                  (queueItem?.checkpointDetail | misc: "jsonParse")?.site_name
                ) {
                  <dl>
                    <dt>Site</dt>
                    <dd>
                      {{
                        (queueItem?.checkpointDetail | misc: "jsonParse")
                          ?.site_name
                      }}
                    </dd>
                  </dl>
                }

                <dl>
                  <dt>Client</dt>
                  <dd>
                    {{
                      (queueItem?.checkpointDetail | misc: "jsonParse")?.company
                    }}
                  </dd>
                </dl>
              }
              @if (["api/patrol/add_update/"].includes(queueItem?.pathName)) {
                <dl>
                  <dt>Patrol Event</dt>
                  <dd>
                    {{
                      queueItem?.file
                        ? "Add Photo"
                        : queueItem?.comment
                          ? "Add Comment"
                          : "Update"
                    }}
                  </dd>
                </dl>

                @if (queueItem?.site_name) {
                  <dl>
                    <dt>Site</dt>
                    <dd>
                      {{ queueItem?.site_name }}
                    </dd>
                  </dl>
                }
                <dl>
                  <dt>Client</dt>
                  <dd>
                    {{ queueItem?.company }}
                  </dd>
                </dl>
              }
              @if (["api/job/update_job/"].includes(queueItem?.pathName)) {
                <dl>
                  <dt>JOB Event</dt>
                  <dd>Add Comment/Photo</dd>
                </dl>
                <dl>
                  <dt>JOB</dt>
                  <dd>
                    {{ (queueItem?.jobDetails | misc: "jsonParse")?.job_key }}
                  </dd>
                </dl>
                <dl>
                  <dt>Client</dt>
                  <dd>
                    {{ (queueItem?.jobDetails | misc: "jsonParse")?.company }}
                  </dd>
                </dl>
              }
              @if (
                ["api/check_point/register_qr/"].includes(queueItem?.pathName)
              ) {
                <dl>
                  <dt>Patrol Event</dt>
                  <dd>
                    {{
                      (queueItem?.form_data | misc: "jsonParse")?.nfc_tag
                        ? (queueItem?.form_data | misc: "jsonParse")?.scanOnly
                          ? "NFC Scan"
                          : "NFC Register "
                        : (queueItem?.form_data | misc: "jsonParse")?.scanOnly
                          ? "QR Scan"
                          : "QR Register "
                    }}
                  </dd>
                </dl>
                <dl>
                  <dt>Checkpoint</dt>
                  <dd>
                    {{ (queueItem?.form_data | misc: "jsonParse")?.name }}
                  </dd>
                </dl>
                <dl>
                  <dt>Site</dt>
                  <dd>
                    {{ (queueItem?.form_data | misc: "jsonParse")?.site }}
                  </dd>
                </dl>
                <dl>
                  <dt>Client</dt>
                  <dd>
                    {{ (queueItem?.form_data | misc: "jsonParse")?.company }}
                  </dd>
                </dl>
              }
              @if (
                ["api/run_sheet/add_update/"].includes(queueItem?.pathName)
              ) {
                <dl>
                  <dt>Scheduled Patrol Update</dt>
                  <dd>
                    {{
                      queueItem?.file
                        ? "Add Photo"
                        : queueItem?.mark_complete
                          ? "Task Complete"
                          : queueItem?.comment
                            ? "Add Comment"
                            : "Update"
                    }}
                  </dd>
                </dl>

                <dl>
                  <dt>Patrol Run</dt>
                  <dd>
                    {{ (queueItem?.runSheetDetails | misc: "jsonParse")?.name }}
                  </dd>
                </dl>
              }
              @if (
                ["api/gt_message/send_message/"].includes(queueItem?.pathName)
              ) {
                <dl>
                  <dt>Chat Message</dt>
                  <dd>
                    {{ queueItem?.file ? "Photo" : "Message" }}
                  </dd>
                </dl>

                <dl>
                  <dt>To</dt>
                  <dd>
                    {{
                      (queueItem?.messageBody | misc: "jsonParse")?.receiver
                        ?.user_name
                    }}
                  </dd>
                </dl>
              }

              <dl>
                <dt>Time</dt>
                <dd>
                  {{
                    queueItem?.updated_at * 1000 | customDate: "d MMM y HH:mm"
                  }}
                </dd>
              </dl>

              @if (queueItem?.comment) {
                <dl>
                  <dt>Comment</dt>
                  <dd class="small-font">
                    {{ queueItem?.comment }}
                  </dd>
                </dl>
              }
              @if (queueItem?.message) {
                <dl>
                  <dt>Message</dt>
                  <dd class="small-font">
                    {{ queueItem?.message }}
                  </dd>
                </dl>
              }
              @if (queueItem?.file) {
                <dl>
                  <dt>File</dt>
                  <dd class="small-font">
                    <img
                      class="small-img-preview"
                      height="120"
                      width="120"
                      [src]="getImgSrc(queueItem?.file)"
                    />
                  </dd>
                </dl>
              }
            </div>
          </div>
        }
      </div>
    </ng-container>
  } @else {
    <div class="fw-semibold">No updates remain unsent.</div>
  }
  @if (
    ["logout", "multipleAccount", "clockOut"].includes(showFrom) &&
    queuedResposeListData?.length
  ) {
    <div class="my-2 small text-secondary">
      Remove or retry syncing all your pending/queued updates to continue
    </div>
  }
  @if (!offlineMode && !queuedResposeListData?.length) {
    <button
      class="btn btn-lg btn-primary w-100 mt-4"
      (click)="onDialogClose(true)"
    >
      @switch (showFrom) {
        @case ("logout") {
          Sign out
        }
        @case ("clockOut") {
          Clock out
        }
        @case ("multipleAccount") {
          Switch Account
        }
        @default {
          Ok
        }
      }
    </button>
  }

  <!-- <div class="mt-3">
    <div class="d-flex gap-2">
      <button class="btn btn-lg btn-dark w-100" (click)="onDialogClose()">
        Cancel
      </button>

      @if (!offlineMode) {
        @if (queuedResposeListData?.length) {
          <ng-container>
            <button
              class="btn btn-lg btn-primary w-100"
              [disabled]="syncInProgress"
              (click)="retryAllQueuedEvents()"
            >
              Retry All
            </button></ng-container
          >
        } @else {
          <ng-container>
            <button
              class="btn btn-lg btn-primary w-100"
              (click)="onDialogClose(true)"
            >
              @switch (showFrom) {
                @case ("logout") {
                  Sign out
                }
                @case ("multipleAccount") {
                  Switch Account
                }
                @case ("home") {
                  Ok
                }
              }
            </button></ng-container
          >
        }
      }
    </div>
  </div> -->
</div>
